import { InvoiceTotalsApp } from "documenttotals/InvoiceTotalsApp";
import { CopyInvoiceApp } from "invoice/copy/App";
import { InvoiceV1DetailApp } from "invoice/detail/App";
import InvoiceListApp from "invoice/list/app";
import { MakeCreditApp } from "invoice/makecredit/App";
import { NewInvoiceApp } from "invoice/new/App";
import {
  type RouteObject,
} from "react-router";

declare let viewModel: any;

export const invoiceRoute: RouteObject = {
  children: [{
    path: "invoice",
    loader: () => viewModel,
    Component: InvoiceListApp,
  }, {
    path: "invoice/total",
    loader: () => viewModel,
    Component: InvoiceTotalsApp,
  }, {
    path: "invoice/new",
    loader: () => viewModel,
    Component: NewInvoiceApp,
  }, {
    path: "invoice/detail/:key",
    loader: () => viewModel,
    Component: InvoiceV1DetailApp,
  }, {
    path: "invoice/makecredit/:key",
    loader: () => viewModel,
    Component: MakeCreditApp,
  }, {
    path: "invoice/copy/:key",
    loader: () => viewModel,
    Component: CopyInvoiceApp,
  }]
};